import { handleCheckbox, handleCheckBoxLabel } from './utils';
import { Text,Checkbox } from '@chakra-ui/react';
import { getResumeOrSectionIndex } from '../../handlers';

const RSCheckboxField=({ props, qObj, option })=>{

  let index = props.stateProps.sectionData.sectionIndex;
 if(index===-1 ) {
   index=0;
 }
  return(
    <Checkbox
      display="flex"
      key={option.label}
      value={option.value}
      onChange={e =>
        handleCheckbox(
          props,
          e,
          qObj.qid,
          option.value,
          index
        ) }
    >
      <label htmlFor={option.value}
             onClick={e =>
               handleCheckBoxLabel(
                 props,
                 e,
                 qObj.qid,
                 option.value,
                 index
               )
             }>
        <Text pl={6}>{option.label}</Text>
      </label>
    </Checkbox>
  )
}
export default RSCheckboxField;